import { useMemo } from 'react'

import { useGetMyApplications } from '@/utils/api/membership-service'
import type { ApplicationResponseDTO } from '@/utils/api/membership-service/models/application-response-dt-o'
import type { RestPageImpl } from '@/utils/api/membership-service/models/rest-page-impl'

function sortApplicationsByRecency(applications: ApplicationResponseDTO[]): ApplicationResponseDTO[] {
  return [...applications].sort((a, b) => {
    const getDate = (application: ApplicationResponseDTO) => {
      const reference = application.updatedAt ?? application.submittedAt ?? application.createdAt ?? 0
      return new Date(reference).getTime()
    }
    return getDate(b) - getDate(a)
  })
}

export function useLatestApplication(options?: { pageSize?: number }) {
  const pageSize = options?.pageSize ?? 100
  const query = useGetMyApplications<RestPageImpl | null>(
    { page: 0, size: pageSize },
    {
      query: {
        staleTime: 60_000,
        select: (response) => response.data ?? null,
      },
    },
  )

  const restPage = query.data

  const applications = useMemo<ApplicationResponseDTO[]>(() => {
    if (!restPage?.content) return []
    return (restPage.content.filter(Boolean) as ApplicationResponseDTO[]) ?? []
  }, [restPage])

  const latestApplication = useMemo<ApplicationResponseDTO | null>(() => {
    if (applications.length === 0) return null
    return sortApplicationsByRecency(applications)[0] ?? null
  }, [applications])

  return {
    latestApplication,
    applications,
    query,
  }
}
